function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 21.6668C8.04449 21.6668 5.52782 20.6279 3.45004 18.5502C1.37226 16.4724 0.333374 13.9557 0.333374 11.0002C0.333374 8.04461 1.37226 5.52794 3.45004 3.45016C5.52782 1.37239 8.04449 0.333496 11 0.333496C12.8889 0.333496 14.5445 0.71683 15.9667 1.4835C17.3889 2.25016 18.6223 3.30016 19.6667 4.6335V0.333496H21.6667V8.80016H13.2V6.80016H18.8C17.9556 5.46683 16.8778 4.38905 15.5667 3.56683C14.2556 2.74461 12.7334 2.3335 11 2.3335C8.57782 2.3335 6.52782 3.17238 4.85004 4.85016C3.17226 6.52794 2.33337 8.57794 2.33337 11.0002C2.33337 13.4224 3.17226 15.4724 4.85004 17.1502C6.52782 18.8279 8.57782 19.6668 11 19.6668C12.8445 19.6668 14.5334 19.1391 16.0667 18.0835C17.6 17.0279 18.6667 15.6335 19.2667 13.9002H21.3334C20.6889 16.2335 19.4112 18.1113 17.5 19.5335C15.5889 20.9557 13.4223 21.6668 11 21.6668Z",
  fill: "#DBC7B8"
});

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.a6e34d24.svg";
export { ForwardRef as ReactComponent };